import type { ErrorRegistryShape } from '../common/common.error';

export const PORTFOLIO_MANAGE_ERROR = {
  NOT_FOUND_ACTION_POINT: { status: 404, message: 'Action point not found' },
  NOT_FOUND_MANAGE_HISTORY: { status: 404, message: 'Manage history not found' },
  /** 미리보기 · 내려받기 티켓이 없거나 만료 · 위조, 또는 그 세션이 끝났다 */
  UNAUTHORIZED_MANAGE_HISTORY_TICKET: { status: 401, message: 'Manage history ticket is invalid' },
  /** 관리 이력은 쓴 사람만 고치고 지운다 */
  FORBIDDEN_NOT_HISTORY_AUTHOR: { status: 403, message: 'Only the author can change this history' },
} as const satisfies ErrorRegistryShape;
